export default __webpack_public_path__ + "static/wolfflabs-logo-300-34290b637cd0c8e30a38660f0be92240.png";